(function () {
  function initGallery(scope) {
    var galleries = scope.querySelectorAll('[data-quite-gallery]');
    galleries.forEach(function (gallery) {
      if (gallery.dataset.quiteGalleryReady === 'true') return;
      gallery.dataset.quiteGalleryReady = 'true';
      var panels = gallery.querySelectorAll('[data-quite-gallery-panel]');
      var thumbs = gallery.querySelectorAll('[data-quite-gallery-thumb]');

      function setActive(index) {
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-gallery-index') === String(index));
        });
        thumbs.forEach(function (thumb) {
          var active = thumb.getAttribute('data-gallery-index') === String(index);
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.setAttribute('aria-pressed', thumb.classList.contains('is-active') ? 'true' : 'false');
        thumb.addEventListener('click', function () {
          if (window.qtrack) window.qtrack('pdp_gallery_nav', { image_index: Number(thumb.getAttribute('data-gallery-index')) || 0 });
          setActive(thumb.getAttribute('data-gallery-index'));
        });
      });
    });
  }

  function initTabs(scope) {
    var groups = scope.querySelectorAll('[data-quite-tabs]');
    groups.forEach(function (group) {
      if (group.dataset.quiteTabsReady === 'true') return;
      group.dataset.quiteTabsReady = 'true';
      var tabs = group.querySelectorAll('[data-quite-tab]');
      var panels = group.querySelectorAll('[data-quite-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-quite-tab');
          if (window.qtrack) window.qtrack('pdp_tab_open', { tab_name: target || (tab.textContent || '').trim().slice(0, 40) });
          tabs.forEach(function (item) {
            item.classList.toggle('is-active', item === tab);
            item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
          });
          panels.forEach(function (panel) {
            panel.classList.toggle('is-active', panel.getAttribute('data-quite-panel') === target);
          });
        });
      });
    });
  }

  function init(root) {
    initGallery(root);
    initTabs(root);
  }

  // Delegated at document level so the handler survives HTML swaps
  // inside product-info custom element on variant change.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-quite-submit-product]')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });

  function initStickyBar() {
    var hero = document.querySelector('[data-quite-hero]');
    var bar = document.querySelector('[data-quite-sticky]');
    if (!hero || !bar) return;

    var stickySeen = false;
    var observer = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      bar.classList.toggle('is-visible', !visible);
      bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      if (!visible && !stickySeen) { stickySeen = true; if (window.qtrack) window.qtrack('pdp_sticky_atc_view', {}); }
    }, { threshold: 0 });

    observer.observe(hero);
  }

  // When a pack variant is selected, swap the first gallery image to that
  // pack's product image (e.g. the 2-pack bundle) for visual reinforcement.
  // Selecting the first pack (1-pack) restores the original hero artwork.
  function initPackImageSync() {
    if (window.__quitePackSync) return;
    window.__quitePackSync = true;

    var defaultPanelSrc = null;
    var defaultThumbSrc = null;

    function els() {
      return {
        panel: document.querySelector('[data-quite-gallery-panel][data-gallery-index="0"]'),
        thumb: document.querySelector('[data-quite-gallery-thumb][data-gallery-index="0"] img'),
        gallery: document.querySelector('[data-quite-gallery]'),
        picker: document.querySelector('.quite-variant-picker')
      };
    }

    function showFirst(gallery) {
      if (!gallery) return;
      gallery.querySelectorAll('[data-quite-gallery-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-gallery-index') === '0');
      });
      gallery.querySelectorAll('[data-quite-gallery-thumb]').forEach(function (t) {
        var active = t.getAttribute('data-gallery-index') === '0';
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function sync() {
      var e = els();
      if (!e.panel || !e.picker) return;
      if (defaultPanelSrc === null) {
        defaultPanelSrc = e.panel.getAttribute('src');
        defaultThumbSrc = e.thumb ? e.thumb.getAttribute('src') : null;
      }
      var radios = e.picker.querySelectorAll('input[type="radio"][data-option-value-id]');
      if (!radios.length) return;
      var checked = e.picker.querySelector('input[type="radio"][data-option-value-id]:checked') || radios[0];
      var isFirstPack = checked === radios[0];
      var packImg = checked.getAttribute('data-quite-pack-image');
      if (!isFirstPack && packImg) {
        e.panel.setAttribute('src', packImg);
        if (e.thumb) e.thumb.setAttribute('src', packImg);
      } else {
        e.panel.setAttribute('src', defaultPanelSrc);
        if (e.thumb && defaultThumbSrc) e.thumb.setAttribute('src', defaultThumbSrc);
      }
      showFirst(e.gallery);
    }

    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.matches && ev.target.matches('.quite-variant-picker input[type="radio"][data-option-value-id]')) {
        if (window.qtrack) {
          var lbl = '';
          try { var id = ev.target.id; var l = id && document.querySelector('label[for="' + id + '"]'); lbl = (l ? l.textContent : ev.target.value) || ''; } catch (e) {}
          window.qtrack('pdp_pack_select', { variant_title: lbl.trim().replace(/\s+/g, ' ').slice(0, 60) });
        }
        sync();
      }
    });

    sync();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.quite-pdp').forEach(init);
    initStickyBar();
    initPackImageSync();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) init(event.target);
  });
})();
